import { ChangeEvent } from 'react'
import { useFormContext } from 'react-hook-form'
import { Checkbox } from '@mui/material'

import { DefaultElementProps } from 'common/interfaces'
import { switchersStyle, switcherWithSubheadingPrivateSwitchBase } from 'common/styles'
import CheckboxGroupWrapper from 'components/CheckboxGroupWrapper'
import FormControlLabel from 'components/FormControlLabel'
import FormControlLabelInner from 'components/FormControlLabelInner'

import { CheckboxGroup as CheckboxGroupProps, CheckboxGroupOption } from './interface'

function renderOption(
  option: CheckboxGroupOption,
  valueState: Record<string, boolean>,
  handleChange: (id: string, event: ChangeEvent<HTMLInputElement>) => void
): JSX.Element {
  const { value, label, subheading } = option
  return (
    <FormControlLabel
      key={value}
      label={<FormControlLabelInner label={label} subheading={subheading} />}
      checked={valueState[value]}
      sx={subheading !== undefined ? switcherWithSubheadingPrivateSwitchBase : {}}
      control={
        <Checkbox
          sx={switchersStyle}
          checked={valueState[value]}
          onChange={(event) => handleChange(value, event)}
        />
      }
    />
  )
}

export default function CheckboxGroup({
  name,
  size,
  label,
  options,
  onFocus,
  onChange,
  direction,
  validations,
}: CheckboxGroupProps & DefaultElementProps): JSX.Element {
  const { control } = useFormContext()

  const defaultValue = options.reduce(
    (acc, opt) => ({
      ...acc,
      [opt.value]: opt.defaultChecked ?? false,
    }),
    {}
  )

  return (
    <CheckboxGroupWrapper
      classNames="checkbox-wrap"
      control={control}
      options={options}
      name={name}
      validations={validations}
      size={size}
      label={label}
      direction={direction}
      renderOption={renderOption}
      defaultValue={defaultValue}
      onFocus={onFocus}
      onChange={onChange}
    />
  )
}
